import React, {Component, PropTypes} from 'react';
import {connect} from 'react-redux';

@connect((state) => ({
  error: state.status.error,
  ready: state.status.ready,
}))

// eslint-disable-next-line react/prefer-stateless-function
export default class AppContainer extends Component {
  static propTypes = {
    children: PropTypes.object,
    error: PropTypes.object,
    ready: PropTypes.bool,
  };

  render() {
    const {
      error,
      ready,
      children,
    } = this.props;

    const errorComponent = error ?
      (<div className="text-center">
        <span className="alert alert--error">
          Oh no, there was a problem: {error.message}
        </span>
      </div>) : null;

    const loadingComponent = ready ? null : (
      <div className="loading-overlay text-center">
        <span className="icon-text-container">
          <i className="icon-spinner icon-spin" />
          Loading ...
        </span>
      </div>
    );

    return (
      <div>
        {loadingComponent}
        {errorComponent}
        <div style={{opacity: ready ? 1 : 0.2}}>
          {children}
        </div>
      </div>);
  }
}
